module.exports = __webpack_public_path__ + "img/horizontal_card.ebe05eb8.png";